import { Button, Line, ModalBody, ModalHeader, P } from "@sorcery/ui";

import { SearchAllBox } from "~/components/organisms/SearchAllBox";
import { useModal } from "~/providers/ModalProvider";

export const SearchModal = () => {
  const { closeModal } = useModal();

  return (
    <div className="p-6">
      <ModalHeader title="Search Curiosa" />

      <ModalBody>
        {/* item */}
        <div className="mb-2 w-full">
          <P>Find decks, cards, and users.</P>
          <SearchAllBox />
        </div>
      </ModalBody>

      {/* footer */}
      <Line />
      <div className="flex flex-row-reverse pt-4 gap-2">
        <Button onClick={closeModal} variant="secondary">
          Close
        </Button>
      </div>
    </div>
  );
};
